import React from 'react'
import { connect } from 'react-redux'
import EsimActions from '../../Redux/EsimRedux'

class UpdateVarianEsim extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      form: {
        price: props.variant.price || 0
      },
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault();
    let data = {
      id: this.props.detail.id,
      variant_id: this.props.variant.id,
      form: {
        price: this.state.form.price
      }
    }

    this.props.submit(data)

    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render() {
    return (
      <section className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Varian - {this.props.variant.data_size}/{this.props.variant.day} day</h4>
        </div>
        <form onSubmit={event => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Base Price</label>
            </div>
            <div className='col-9'>
              <input className='form-control' value={this.props.variant.base_price} disabled />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Price</label>
            </div>
            <div className='col-9'>
              <input className='form-control' value={this.state.form.price} onChange={event => this._inputChange(event, "price")} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  esims: state.esims,
})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(EsimActions.esimUpdateVariantRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateVarianEsim)



// WEBPACK FOOTER //
// ./src/Containers/Esim/UpdateVarianEsim.js